<template>
	<li class="post col py-0" style="height: 60px;">
		<div class="row my-auto mx-0 vertical-center">

			<div v-if="isEditableVal">
				<span class="column-drag-handle grabbable"><i class="fontello icon-menu"></i></span>
			</div>
			<div>
				<i class="fontello icon-chat mr-2" style="color: #303133"/>
			</div>
			<div class="col p-0 h-100">
				<div class="my-auto">{{ programStep.name}}</div>
				<div v-if="programStep.durationMinutes" class="text-muted">
					<small>Duration: {{programStep.durationMinutes}} minutes</small>
				</div>
			</div>
			<div class="float-right text-right">
				<small>
					<div v-if="program.isProcess()">

						<div v-if="programStep.needsConfirmation(currentUser.email)">
							<div v-if="!programStep.doWeNeedToConfirm(currentUser.uid)" class="row mx-0 align-items-center">
								<ToolTipView :analyticsProps="{label: 'Not confirmation session', ...analyticsPropsMethod()}" >
									<template #icon><div>
										<span class="mr-2">Not yet confirmed</span>
										<span  class="dot badge-warning"></span>
									</div></template>
									This session is not yet confirmed.
<!--									<br/>-->
<!--									<br/>-->
<!--									Click this session to set a time or to invite your client to schedule this session.-->
								</ToolTipView>

							</div>
							<div v-else>
								<span class="mr-2">Pick a time</span>
								<ToolTipView :analyticsProps="{label: 'Not confirmation session', ...analyticsPropsMethod()}" >
									<template #icon><i  class="fontello icon-attention text-warning"/></template>
									This session needs confirmation
								</ToolTipView>
<!--								<span class="dot badge-warning"></span>-->
							</div>
						</div>
						<div v-else class="row mx-0 align-items-center">
							<ToolTipView :analyticsProps="{label: 'Recurring session', ...analyticsPropsMethod()}"
										 v-if="programStep.isRecurring">
								<template #icon><i  class="fontello icon-arrows-cw pr-2" style="color: rgb(118, 119, 121)"/></template>
								This session is part of repeating series.
								<br/><br/>
								New sessions will appear automatically as current sessions are completed.
							</ToolTipView>
								<div class="mr-2"
								:class="{'strike-through': programStep.isSessionCancelled()}">
									{{programStep.confirmedTimeFormatted("ddd, MMM DD")}}
									<br/>
									at {{programStep.confirmedTimeFormatted("hh:mma")}}
								</div>
							<ToolTipView :analyticsProps="{label: 'Cancelled session', ...analyticsPropsMethod()}"
								v-if="programStep.isSessionCancelled()">
								<template #icon><span  class="dot badge-warning"></span></template>
								This session was cancelled
							</ToolTipView>
							<ToolTipView :analyticsProps="{label: 'Completed session', ...analyticsPropsMethod()}"
								v-else-if="programStep.isCallCompleted()">
								<template #icon><span  class="dot badge-default"></span></template>
								This session is completed
							</ToolTipView>
							<ToolTipView :analyticsProps="{label: 'Upcoming session', ...analyticsPropsMethod()}"
								v-else>
								<template #icon><span  class="dot badge-success"></span></template>
								This is an upcoming session
							</ToolTipView>


						</div>
					</div>
					<div v-else>
<!--						To be confirmed-->
					</div>

				</small>
			</div>
		</div>

	</li>
</template>


<script>
    import BaseRow from "./BaseRow"
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

    export default {
        name: "CallRow",
		components: {ToolTipView},
		extends: BaseRow,
		props:{
			tooltipAnalyticsProps: Object
		},

	}
</script>

<style>

</style>
